export const danger = '#E30712'
export const normal = '#00a0bd'
